"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchScreen = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * Screen component, renders a screen with a header
 * @param props
 */
const SwitchScreen = (props) => {
    const { Screen, route, options, navigator } = props, rest = tslib_1.__rest(props, ["Screen", "route", "options", "navigator"]);
    return Screen ? react_1.default.createElement(Screen, Object.assign({}, rest)) : rest.children;
};
exports.SwitchScreen = SwitchScreen;
exports.SwitchScreen.displayName = 'SwitchScreen';
